module.exports = __webpack_public_path__ + "img/null_bg2.f3f20b36.png";